<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('文件名称')">
              <j-input :placeholder="$t('输入文件名称模糊查询')" v-model="queryParam.fileName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button> -->
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <!-- <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">回收站</a-button> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <FileManagementListModal ref="FileManagementListRef" @ok="modalFormOk" />

  </a-card>
</template>

<script>
  import {putAction,getFileAccessHttpUrl,postAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import FileManagementListModal from './modules/FileManagementListModal'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'

  export default {
    name: "FileManagementList",
    mixins: [JeecgListMixin],
    components: {
      JInput,
      FileManagementListModal
    },
    data() {
      return {
        description: this.$t('这是文件管理页面'),
        queryParam: {},
        recycleBinVisible: false,
        url: {
          list: "/jeecg-system/user/userFile/list",
          queryById: "/sys/userExpectionRecord/edit",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('文件名称'),
            align: "center",
            dataIndex: 'fileName',
            width: 120,
            ellipsis: true,
          },
          {
            title: this.$t('地区码'),
            align: "center",
            width: 100,
            dataIndex: 'sysOrgCode',
            ellipsis: true,
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            width: 150,
            dataIndex: 'createTime',
            ellipsis: true,
          },
          {
            title: this.$t('创建人'),
            align: "center",
            width: 150,
            dataIndex: 'createBy',
            ellipsis: true,
          },
          {
            title: this.$t('文件描述'),
            align: "center",
            width: 200,
            dataIndex: 'fileDescription',
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100
          }

        ]
      }
    },
    methods: {
      handleAdd(){
        this.$refs.FileManagementListRef.init({},'add');
      },
      handleEdit(row){
        this.$refs.FileManagementListRef.init(row,'edit');
      },
      handleDetail(row){
        this.$refs.FileManagementListRef.init(row,'detail');
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>